<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-04-02 17:43:01
 -->
<template>
  <div class="foot-info">Copyright © 2020 苏州德运通信息科技有限公司</div>
</template>

<script>
export default {
  name: 'bottom'
}
</script>

<style scoped>
div.foot-info{
  height:00px;
  line-height:00px;
  text-align: right;
  font-size: 0px;
  color: #999999;
}
</style>



// WEBPACK FOOTER //
// src/pages/layout/Footer/bottom.vue